export default __webpack_public_path__ + "static/media/ic_history.f5fd2d13.svg";